import { useCountry } from "@/lib/CountryContext";

/**
 * Thin 3-band flag-coloured stripe placed just below the Navbar.
 *
 * Visible identifier that reinforces *which* country the user is on, alongside
 * the per-country body background. Picks colours from the theme.stripeColors
 * array set in countries.js.
 */
export default function CountryStripe() {
  const { code, country } = useCountry();
  return (
    <div
      className="w-full h-[5px] flex shadow-sm pointer-events-none"
      data-testid={`country-stripe-${code}`}
      aria-hidden="true"
      title={country.name}
    >
      <span className="flex-1" style={{ backgroundColor: "var(--country-stripe-1)" }} />
      <span className="flex-1" style={{ backgroundColor: "var(--country-stripe-2)" }} />
      <span className="flex-1" style={{ backgroundColor: "var(--country-stripe-3)" }} />
    </div>
  );
}
